import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchMyShortcut } from 'api/myShortcut.service';
import { notificationActions } from 'redux/notification/notification.slice';
import { FavoriteListRegister, MyFavoritesResponseModel } from 'types/entity-ddms';

export const MY_SHORTCUT_READ_STORE_NAME = 'myShortcutRead';

export const loadMyShortcut = createAsyncThunk(
  `${MY_SHORTCUT_READ_STORE_NAME}/load`,
  async (data: FavoriteListRegister, thunkAPI) => {
    const response = await fetchMyShortcut(data);
    if (response.length !== 1) {
      thunkAPI.dispatch(notificationActions.addSuccess({ messageId: 'myshortcut.error.model' }));
    }
    return response[0]?.my_favorites || [];
  },
);

export type MyShortcutReadState = {
    loaded: boolean
    entity: MyFavoritesResponseModel[]
    error: any
}

export const initialMyShortcutReadState: MyShortcutReadState = {
  entity: [],
  loaded: false,
  error: null,
};

export const myShortcutReadSlice = createSlice({
  name: MY_SHORTCUT_READ_STORE_NAME,
  initialState: initialMyShortcutReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadMyShortcut.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadMyShortcut.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.loaded = true;
    });
    builder.addCase(loadMyShortcut.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
  },
});

export const myShortcutReadAction = {
  ...myShortcutReadSlice.actions,
  loadMyShortcut,
};

export default myShortcutReadSlice.reducer;
